<template>
  <div class="wrapper">
    <div class="header-wrapper">
      <div class="left">
        <div class="iconfont icon-fanhui2" style="font-size:35px" @click="goback"></div>
      </div>
      <div class="header">{{this.comeType == '11'?'居民议事厅':'党委联席会议'}}</div>
      <div class="newvote">
        <Button class="btn-dc" type="primary" @click="edit">编辑</Button>
      </div>
    </div>
    <div class="content">
      <Card>
        <div class="card-con">
          <Form :label-width="80">
            <FormItem label="封面图">
              <img class="fengmian" :src="imgUrl" v-if="imgUrl" alt />
              <p class="d-form" v-else>暂无封面</p>
            </FormItem>
            <FormItem label="话题">
              <p class="d-form">{{title}}</p>
            </FormItem>
            <FormItem label="详情">
              <p class="d-form">{{detail}}</p>
            </FormItem>
            <FormItem label="开始时间">
              <p class="d-form">{{time}}</p>
            </FormItem>
            <FormItem label="地点">
              <p class="d-form">{{address}}</p>
            </FormItem>
            <FormItem label="参会人">
              <!-- <p class="d-form">{{people}}</p> -->
              <div class="box poeplecontent">
                <div v-for="item in people" :key="item.id" class="box peoplelist">
                  <div class="realName marg_right6">{{item.realName}}</div>
                  <div class="d-form marg_right6" v-if="item.userName">{{ '('+item.userName+')'}}</div>
                </div>
              </div>
            </FormItem>
            <FormItem label="短信通知">
              <p class="d-form">{{notice}}</p>
            </FormItem>
            <FormItem label="发布至">
              <p class="d-form">{{community}}</p>
            </FormItem>
            <FormItem label="是否置顶">
              <p class="d-form">{{isTop}}</p>
            </FormItem>
          </Form>
        </div>
      </Card>
      <Card style="margin-top: 20px">
        <div class="card-con">
          <Form :label-width="80">
            <FormItem label="议事结果">
              <div style="font-size:14px" v-html="resultContent"></div>
            </FormItem>
            <FormItem label="附件">
              <div class="img-con" v-for="(item, index) in fujian" :key="index">
                <img :src="item.attachmentUrl" class="res-img" v-if="!item.timeLength" alt />
                <video :src="item.attachmentUrl" class="res-img" v-if="item.timeLength"></video>
                <div class="play" v-if="item.timeLength">
                  <i class="iconfont icon-shipinbofang-" @click="play(item)"></i>
                </div>
              </div>
            </FormItem>
          </Form>
        </div>
      </Card>
    </div>
    <Modal title="视频播放" v-model="visible" @on-ok="modalOk" @on-cancel="modalCancel">
      <video-player class="vjs-custom-skin" ref="videoPlayer" :options="options" :playsinline="true"></video-player>
    </Modal>
    <Spin fix v-if="loading"></Spin>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css'
import {
  videoPlayer
} from 'vue-video-player'
export default {
  data() {
    return {
      comeType:this.$route.query.comeType,
      id: "",
      imgUrl: '',
      title: '',
      detail: '',
      address: '',
      time: '',
      people: '',
      notice: '',
      community: '',
      isTop: '',
      result: '',
      fujian: [],
      loading: false,
      resultContent: '',
      visible: false,
      options: {//属性
        muted: false,
        autoplay: false,//自动播放
        width: "490",//宽度
        sources: [{//视频内容
          src: ''
        }]
      }
    };
  },
  components: {
    videoPlayer
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    getDetail() {
      let url = this.urlobj.assDetail(this.id);
      this.loading = true
      this.$get(url)
        .then(res => {
          this.loading = false
          let reData = res.rows[0]
          let list = reData.attachmentList.map(item => {
            if(item.isResult == 0) {
              return item
            }
          })
          this.imgUrl = list.length ? list[0].attachmentUrl : null
          this.title = reData.title
          this.detail = reData.content
          this.time = reData.beginTime.substr(0, reData.beginTime.length - 5)
          this.address = reData.address.substr(0, reData.address.length - 1)
          // let people = reData.userList.map(item => {
          //   return (item.realName?item.realName:'暂无姓名')+'（'+item.userName+'）'
          // })
          //this.people = people.join('、')
          
          //处理参会人数据
          let peopleList = []
          Object.keys(reData.join).forEach(key=>{
            reData.join[key].forEach(item=>{
                peopleList.push({
                  id:key == 'company' ? item.id:item.uId,
                  userName:key == 'company' ? '' : item.userName,
                  realName:key == 'company' ? item.name : item.realName?item.realName:'暂无姓名',
                })
            })
            
          })
          this.people = peopleList
          let zone = reData.zoneList.map(item => {
            return item.zoneName
          })
          this.community = zone.join('、')
          this.notice = reData.isSendMsg ? '是' : '否'
          this.isTop = reData.isTop ? '是' : '否'
          this.resultContent = reData.resultContent
          let fujian = []
          reData.attachmentList.forEach(item => {
            if(item.isResult == 1){
              fujian.push(item)
            }
          })
          this.fujian = fujian
          console.log(fujian)
        }).catch(e => {
          this.loading = false
        })
        
    },
    play(item) {
      this.visible = true
      this.options.sources[0].src = item.attachmentUrl
    },
    modalOk() { //点击确定按钮暂停视频，关闭对话框
      this.visible = false;
      this.$refs.videoPlayer.player.pause();
    },
    modalCancel() { //点击取消按钮暂停视频，关闭对话框
      this.visible = false;
      this.$refs.videoPlayer.player.pause();
    },
    edit() {
      this.$router.push({name: 'assemblyNew', query: {id: this.id,comeType:this.comeType}})
    }
  },
  mounted() {
    this.getDetail();
  },
  created() {
    this.id = this.$route.query.id;
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    }
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  color: #666666;
  overflow: hidden;
  height: 100%;
}

.wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 4px; */
}
.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}
.left {
  position: absolute;
  left: 20px;
  font-size: 22px;
}
.header {
  font-size: 25px;
  text-align: center;
}
.newvote {
  position: absolute;
  right: 20px;
  button {
    width: 80px;
    height: 28px;
    line-height: 13px;
  }
  .btn-dc {
    background-color: #ff7c43;
    border-color: #ff7c43;
  }
}
.content {
  // max-width: 96%;
  margin: 20px;
}
.add-con {
  font-size: 16px;
  color: #999;
  width: 110px;
  height: 30px;
  line-height: 30px;
  padding: 0 5px;
}
.fengmian {
  width: 240px;
  height: 150px;
}
label {
  margin-right: 20px;
}
.d-form {
  font-size: 14px;
  color: #9a9a9a;
}
.res-img {
  width: 100px;
  height: 72px;
  background: #e1e1e1;
}
/deep/ .ivu-form-item-label {
  font-size: 16px;
  color: #333;
  margin-top: -3px;
}
.card-con {
  width: 700px;
  margin: 0 auto;
}
.img-con {
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 20px;
  width: 100px;
  height: 72px;
  position: relative;
}
.play {
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  height: 72px;
  display: flex;
}
.icon-shipinbofang- {
  margin: auto;
  font-size: 32px;
  opacity: 0.9;
}
.poeplecontent{
  flex-wrap:wrap;
}
.peoplelist:after {    
    content: '、';
    display: block;
}
.peoplelist:last-child::after {    
    content: '';
    display: block;
}
.realName{
  color:#666;
  font-size: 16px;
}
.marg_right6{
  margin-right: 6px;
}
</style>